import { config } from '../../config';

export const getCloudinaryImage = (
  id: string,
  width?: number,
  height?: number
) => {
  if (width && height) {
    return `https://res.cloudinary.com/${config.cloudinary.name}/w_${width},h_${height}/${id}.jpg`;
  } else if (width) {
    return `https://res.cloudinary.com/${config.cloudinary.name}/w_${width}/${id}.jpg`;
  } else if (height) {
    return `https://res.cloudinary.com/${config.cloudinary.name}/h_${height}/${id}.jpg`;
  } else {
    return `https://res.cloudinary.com/${config.cloudinary.name}/${id}.jpg`;
  }
};
